import { useEffect } from 'react';

/**
 * Hook, ktorý presmeruje klávesu Enter na Tab
 * Zachytáva všetky stlačenia klávesy Enter v aplikácii a simuluje stlačenie klávesy Tab
 */
const useEnterAsTab = () => {
  useEffect(() => {
    // Handler pre zachytenie klávesy Enter
    const handleEnterAsTab = (event) => {
      // Kód klávesy Enter je 13
      if (event.key === 'Enter' || event.keyCode === 13) {
        // Vynechať Enter v textových poliach s viaceriadkovým textom (textarea)
        // Tie majú tagName 'TEXTAREA' alebo sú INPUT s typom 'textarea'
        if (event.target.tagName === 'TEXTAREA' || 
            (event.target.tagName === 'INPUT' && event.target.type === 'textarea') ||
            event.target.name === 'ubytko_pozn' || 
            event.target.name === 'lek_zaznamy') {
          // ZACHOVÁVAME predvolené správanie Enter pre textové polia, aby fungoval nový riadok
          return; 
        }
        
        // Zabrániť predvolenému správaniu (odoslanie formulára) pre ostatné polia
        event.preventDefault();
        
        // Vynechať Enter v tlačidlách
        if (event.target.tagName === 'BUTTON' || 
            (event.target.tagName === 'INPUT' && event.target.type === 'submit') ||
            (event.target.tagName === 'INPUT' && event.target.type === 'button')) {
          return;
        }

        // Získanie všetkých fokusovateľných elementov
        const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusableElementsArray = Array.from(document.querySelectorAll(focusableElements));
        
        // Odfiltruj zakrýté a deaktivované elementy
        const visibleFocusableElements = focusableElementsArray.filter(el => {
          return el.offsetWidth > 0 && el.offsetHeight > 0 && !el.disabled;
        });
        
        // Nájdenie aktuálne zameraného elementu
        const activeElementIndex = visibleFocusableElements.indexOf(document.activeElement);
        
        // Výpočet ďalšieho indexu
        const nextIndex = activeElementIndex + 1 < visibleFocusableElements.length ? 
                         activeElementIndex + 1 : 0;
        
        // Presun focus na ďalší element
        visibleFocusableElements[nextIndex].focus();
        
        // Ak je to vstupné pole, vybrať celý text
        if (visibleFocusableElements[nextIndex].tagName === 'INPUT' && 
            (visibleFocusableElements[nextIndex].type === 'text' || 
             visibleFocusableElements[nextIndex].type === 'email' || 
             visibleFocusableElements[nextIndex].type === 'number' || 
             visibleFocusableElements[nextIndex].type === 'tel')) {
          visibleFocusableElements[nextIndex].select();
        }
        
      }
    };

    // Pridanie event listenera na celý dokument
    document.addEventListener('keydown', handleEnterAsTab);

    // Cleanup pri odmontovaní komponentu
    return () => {
      document.removeEventListener('keydown', handleEnterAsTab);
    };
  }, []);
};

export default useEnterAsTab;
